<template>
    <table class="table custom-stripe">
        <tr>
            <td width="200">{{ uLang('app.name') }}:</td>
            <td v-if="relation.title !== 'other'">
                {{ uLang('app.' + relation.title) }} {{ relation.full_name }}
            </td>
            <td v-else>
                {{ relation.full_name }}
            </td>
        </tr>
        <tr v-if="relation.type">
            <td>{{ uLang('app.type') }}: </td>
            <td>{{ relation.type.name }}</td>
        </tr>
        <tr v-if="relation.email">
            <td>{{ uLang('app.email') }}: </td>
            <td><mail :address="relation.email"></mail></td>
        </tr>
        <tr v-if="relation.full_phone_number">
            <td>{{ uLang('app.phone_number') }}: </td>
            <td><tel :number="relation.full_phone_number"></tel></td>
        </tr>
        <tr v-if="relation.full_mobile">
            <td>{{ uLang('app.mobile') }}: </td>
            <td><tel :number="relation.full_mobile"></tel></td>
        </tr>
        <tr v-if="showFieldForClient && relation.birth_date">
            <td>{{ uLang('app.birth_date') }}: </td>
            <td>{{ relation.birth_date | date }}</td>
        </tr>
        <tr v-if="relation.sickness_started_at">
            <td>{{ uLang('app.sickness_started_at') }}: </td>
            <td>{{ relation.sickness_started_at | date }}</td>
        </tr>
        <tr v-if="showFieldForClient && !relationIsCandidate() && relation.organisation">
            <td>{{ uLang('app.organisation') }}:</td>
            <td><router-link :to="{
                    name: 'admin.organisations.view',
                    params: {
                        id: relation.organisation.id
                    }
                }">{{ relation.organisation != null ? relation.organisation.name : null }}
            </router-link></td>
        </tr>
        <tr v-if="showFieldForClient && !relationIsCandidate() && relation.job_title">
            <td>{{ uLang('app.job_title') }}: </td>
            <td>{{ relation.job_title }}</td>
        </tr>
        <tr v-if="showFieldForClient && relationIsCoach() && relation.unavailable_period_start">
            <td>{{ uLang('app.unavailable_period') }}: </td>
            <td>{{ relation.unavailable_period_start | date }} - {{ relation.unavailable_period_end | date }}</td>
        </tr>
        <tr v-if="showFieldForClient && relationIsCoach() && relation.max_trajectories">
            <td>{{ uLang('app.max_trajectories') }}: </td>
            <td>{{ relation.max_trajectories }}</td>
        </tr>
        <tr v-if="showFieldForClient && relationIsCoach() && relation.rebate">
            <td>{{ uLang('app.credit') }}:</td>
            <td>{{ relation.rebate }}%</td>
        </tr>
        <tr v-if="relationIsCoach() && relation.region_name">
            <td>{{ uLang('app.region') }}:</td>
            <td>{{ relation.region_name }}</td>
        </tr>
        <tr v-if="showFieldForClient && relationIsCandidate() && relation.citizen_identifier">
            <td>{{ uLang('app.citizen_identifier') }}:</td>
            <td>{{ relation.citizen_identifier }}</td>
        </tr>
        <tr v-if="showFieldForClient">
            <td>{{ uLang('app.active') }}:</td>
            <td>
                <b-badge pill variant="primary">{{ uLang('app.' + (relation.active ? 'yes' : 'no')) }}</b-badge>
            </td>
        </tr>
        <tr v-if="showFieldForClient">
            <td>{{ uLang('app.created_at') }}:</td>
            <td>{{ moment(relation.created_at).format('DD-MM-YYYY') }}</td>
        </tr>
        <tr v-if="relationIsCandidate()">
            <td>Geeft toestemming voor KTO:</td>
            <td><b-badge pill variant="primary">{{ relation.candidate_ok_survey == null ? "-" : (relation.candidate_ok_survey === 1) ? "Ja" : "Nee"  }}</b-badge></td>
        </tr>
        <!-- <tr v-if="relationIsCoach() || relationIsInspector()"> Not for now, we need to clarify relation Inspector-Enrolment -->
        <tr v-if="relationIsCandidate()">
            <td>Totaal gelogde tijd:</td>
            <td>{{ relation.time_spent }}</td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: 'BasicInfoTable',

        props: {
            relation: {
                type: Object,
                required: true,
                default: () => {}
            },
        },

        data() {
            return {}
        },

        computed: {
            showFieldForClient() {
                return !(this.relationIsCoach() && $hasType('client'));
            }
        },

        methods: {
            relationIsCandidate() {
                return this.relation.type && this.relation.type.system_name == 'candidate'
            },
            relationIsCoach() {
                return this.relation.type && this.relation.type.system_name == 'coach'
            },
            relationIsInspector() {
                return (
                    this.relation.type &&
                    Array.isArray(this.relation.roles) &&
                    this.relation.roles.some(role => role.system_name === 'trajectory_inspector')
                );
            }
        }
    }
</script>

<style scoped lang="scss">
.table {
    tr:first-child {
        td {
            border-top: none;
        }
    }
    td {
        padding-left: 0px !important;
    }
}
</style>
